import { useCallback } from 'react';
import { notification } from 'components';
import { useTaskDeleteMutation } from 'api';
import { ErrorMappingValueType } from 'typings';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const [deleteTask, { isLoading }] = useTaskDeleteMutation();
  const handleErrors = useCallback(
    (error: any) => {
      if (!error?.data?.success && error?.data?.data) {
        Object.values(error.data.data).forEach((message) => {
          openNotificationWithIcon({
            type: 'error',
            message: message as string,
          });
        });
      } else {
        openNotificationWithIcon({
          type: 'error',
          message: 'Something went wrong!',
        });
      }
    },
    [openNotificationWithIcon]
  );

  const onRemoveConfirm = useCallback(
    async (task: Record<string, any> | undefined) => {
      if (task) {
        try {
          const response = await deleteTask(task.id);
          if (response?.data?.success) {
            openNotificationWithIcon({
              type: 'success',
              message: 'Task was successfully deleted.',
            });
            onDeleteModalClose();
          } else {
            handleErrors(response.error);
          }
        } catch (err) {
          handleErrors(err);
        }
      }
    },
    [deleteTask, openNotificationWithIcon, onDeleteModalClose, handleErrors]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
